<template>
  <div>
    <van-nav-bar
        style="position: fixed; top: 0; left: 0; width: 100%; background-color: #ffffff"
        title="消息中心"
        left-arrow
        @click-left="$router.back()"
    />
    <div style="height: 60px"></div>
    <div class="van-tabs-view van-tabs">
      <div class="van-tabs__wrap">
        <div role="tablist" class="van-tabs__nav van-tabs__nav--card">
          <div
              role="tab"
              @click="changType(1)"
              aria-selected="true"
              :class="type == 1 ? 'van-tab van-tab--active' : 'van-tab'"
          >
            <span class="van-tab__text van-tab__text--ellipsis">公告</span>
          </div>
          <div
              role="tab"
              @click="changType(2)"
              :class="type == 2 ? 'van-tab van-tab--active' : 'van-tab'"
          >
            <span class="van-tab__text van-tab__text--ellipsis">站内信</span>
          </div>
        </div>
      </div>
      <div class="van-tabs__content" style="width: 90%; margin: 0 auto">
        <!-- 公告列表 -->
        <div v-if="type == 1" role="tabpanel" class="van-tab__pane">
          <van-list v-if="homenoticelis.length > 0">
            <van-cell v-for="(item, index) in homenoticelis" :key="'notice-'+index">
              <div class="content">{{ item.name }}</div>
              <div class="content" v-html="item.content"></div>
            </van-cell>
          </van-list>
          <van-divider
              v-else
              dashed
              :style="{ color: '#ccc', borderColor: '#ccc', padding: '20px 100px' }"
          >
            暂无公告
          </van-divider>
        </div>

        <!-- 站内信列表 -->
        <div v-if="type == 2" role="tabpanel" class="van-tab__pane">
          <van-list v-if="noticeList.length > 0">
            <van-cell v-for="(item, index) in noticeList" :key="'message-'+index">
              <div class="content">{{ item.title }}</div>
              <div class="content"  v-html="item.content"></div>
              <div class="content time">{{ item.created_at }}</div>
            </van-cell>
          </van-list>
          <van-divider
              v-else
              dashed
              :style="{ color: '#ccc', borderColor: '#ccc', padding: '20px 100px' }"
          >
            暂无站内信
          </van-divider>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'message',
  data() {
    return {
      type: 1,
      noticeList: [],
      homenoticelis: [],
      noticeListInfo: {},
      loading: false
    };
  },
  created() {
    let that = this;
    var query = that.$route.query;
    if (query.type) {
      that.type = query.type * 1;
    }

    that.homenotice();
    that.getNoticeListAll();
  },
  methods: {
    changType(type) {
      this.type = type;
      if (type === 1) {
        this.homenotice();
      } else {
        this.getNoticeListAll();
      }
    },

    homenotice() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun.post('/api/homenoticelist', {}).then(res => {
        if (res.code != 200) {
          that.showTost(0, res.message);
        }
        // if (res.code == 200) {
        //   that.homenoticelis = res.data;
        // }


        if (res.code == 200) {
          that.homenoticelis = res.data.data;

          // 如果有更多页，继续获取
          if (res.data.last_page > 1) {
            const promises = [];
            for (let page = 2; page <= res.data.last_page; page++) {
              promises.push(that.$apiFun.post('/api/homenoticelist', { page }));
            }

            Promise.all(promises)
                .then(results => {
                  results.forEach(result => {
                    if (result.code === 200) {
                      that.homenoticelis = [...that.homenoticelis, ...result.data.data];
                    }
                  });
                })
                .finally(() => {
                  that.loading = false;
                  that.$parent.hideLoading();
                });
          } else {
            that.loading = false;
            that.$parent.hideLoading();
          }
        }









        that.$parent.hideLoading();
      });
    },

    // 获取全部站内信
    getNoticeListAll() {
      let that = this;
      that.loading = true;
      that.$parent.showLoading();

      // 获取第一页数据
      that.$apiFun.post('/api/noticeList', { page: 1 })
          .then(res => {
            if (res.code != 200) {
              that.$parent.showTost(0, res.message);
              return;
            }

            if (res.code == 200) {
              that.noticeListInfo = res.data;
              that.noticeList = res.data.data;

              // 如果有更多页，继续获取
              if (res.data.last_page > 1) {
                const promises = [];
                for (let page = 2; page <= res.data.last_page; page++) {
                  promises.push(that.$apiFun.post('/api/noticeList', { page }));
                }

                Promise.all(promises)
                    .then(results => {
                      results.forEach(result => {
                        if (result.code === 200) {
                          that.noticeList = [...that.noticeList, ...result.data.data];
                        }
                      });
                    })
                    .finally(() => {
                      that.loading = false;
                      that.$parent.hideLoading();
                    });
              } else {
                that.loading = false;
                that.$parent.hideLoading();
              }
            }
          })
          .catch(error => {
            console.error(error);
            that.loading = false;
            that.$parent.hideLoading();
          });
    }
  }
};
</script>

<style lang="scss" scoped>
.van-tabs__nav--card .van-tab.van-tab--active {
  color: #fff;
  background-color: #935d94;
}
.van-tabs__nav--card {
  border: 1px solid #935d94;
}
.van-tabs__nav--card .van-tab {
  color: #935d94;
  border-right: 0 solid #935d94;
}

.content {
  margin: 5px 0;
  white-space: pre-wrap;
  word-break: break-word;

  &.time {
    color: #999;
    font-size: 12px;
    text-align: right;
  }
}
</style>